import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-generic-indicator-display',
    templateUrl: './generic-indicator-display.component.html',
    styleUrls: ['./generic-indicator-display.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GenericIndicatorDisplayComponent implements OnInit {

  @Input() mainInfo: string;
  @Input() description: string;
  @Input() icon: string;
  @Input() iconColor: string;

  constructor() { }

  ngOnInit(): void {
  }

}
